import { render, staticRenderFns } from "./BusinessUnitListView.vue?vue&type=template&id=1133b307&scoped=true"
import script from "./BusinessUnitListView.vue?vue&type=script&lang=js"
export * from "./BusinessUnitListView.vue?vue&type=script&lang=js"
import style0 from "./BusinessUnitListView.vue?vue&type=style&index=0&id=1133b307&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133b307",
  null
  
)

export default component.exports